<template>
  <slot v-if="is400FOA"></slot>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useViewerOnOnly400FoaQuery } from './Only400FOA.generated'

const { result } = useViewerOnOnly400FoaQuery()

const is400FOA = computed(() => {
  return result.value?.viewer?.is400FOA ?? false
})
</script>
